import IBaseRespone from '../../model/respone/IBaseRespone';
import httpClient from '../httpService';
import { BSKT_DotHoc } from './DotHocModels';

const DotHocApiUrl = '/api/dothoc/';
export const dotHocService = {
    getAll: async (): Promise<BSKT_DotHoc[]> => {
        const res = await httpClient.get(DotHocApiUrl + 'selectAll');
        return res.data?.data ?? [];
    },
    getById: async (id: number): Promise<BSKT_DotHoc> => {
        const res = await httpClient.get(DotHocApiUrl + 'selectById/' + id);
        return res.data?.data ?? null;
    },
    create: async (dotHoc: BSKT_DotHoc): Promise<IBaseRespone<BSKT_DotHoc>> => {
        const res = await httpClient.post(DotHocApiUrl + 'insert', dotHoc);
        return res.data;
    },
    update: async (dotHoc: BSKT_DotHoc): Promise<IBaseRespone<BSKT_DotHoc>> => {
        const res = await httpClient.post(DotHocApiUrl + 'update', dotHoc);
        return res.data;
    },
    delete: async (id: number): Promise<IBaseRespone<BSKT_DotHoc>> => {
        const res = await httpClient.post(DotHocApiUrl + 'delete/' + id);
        return res.data;
    }
};
